import React from 'react';
import moment from 'moment';
import { Tooltip } from 'antd';
import './styles/SystemMessageItem.css';

const SystemMessageItem = ({
  message: {
    createdAt,
    text,
  },
  style,
}) => (
  <div
    className="system-message-item"
    style={style}
  >
    <Tooltip
      title={moment(createdAt).format('hh:mm a')}
      mouseEnterDelay={0.5}
    >
      {text}
    </Tooltip>
  </div>
);

export default SystemMessageItem;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/ChannelDetail/Message/SystemMessageItem.js